module.exports = __webpack_public_path__ + "static/img/Gacha05.4c1f0b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha05.png
// module id = tCWB
// module chunks = 1